import { Http } from "@/http";
import { Id, res_list, req_list } from "@/types/global";

export interface add_user {
  id:Id;
  phone:string;
  pay_amount:string;
  wallet:string;
  user_wallet:string;
  nickname:string;
  avatar_url:string;
  image: string;
  store:string;
  user_level:string;
  user_meal_id:string;
  mealIds: any[];
  userMealNames: any[];
  member_name: string;
  type: undefined | number;
}
export interface income {
  id: Id;
  user: user;
  price: string;
  amount: string;
  remark: string;
  balance: string;
  order_no: string;
  price_type: string;
  create_time: string;
  update_time: string;
}
export interface user extends add_user {
  superior: string;
  superior_name: string;
  create_time_after: string;
  create_time_before: string;
  user_type: string;
  status: string;
}

export interface scan_pay{
  auth_code: string,
  order_no: string,
}

export interface type {}
export interface pay_check{
  pay_status:number
}

class HttpUser extends Http {
  get_list = (data: req_list) => {
    return this.get<res_list<user>>({ ...data });
  };

  get_info = (id: number) => {
    return this.get<user>({}, `/admin/user/${id}/`);
  };

  edit = ({ id, ...data }: any) => {
    return this.patch(data, `/admin/user/${id}/`);
  };
  create = (data: add_user) => {
    return this.post(data);
  };
  get_house_type_list = (data: req_list) => {
    return this.get<res_list<type>>(data, `/admin/housetypelist/`);
  };

  add_service = (data: { user: number; admin: number }) => {
    return this.post(data, `/admin/user/server/`);
  };

  add_house_type = (data: { user: number; housetype: string }) => {
    return this.post(data, `/admin/user/house/`);
  };

  set_status = (data: { id: number; status: number }) => {
    return this.post(data, `/admin/user/progress/`);
  };

  add_follow = (data: { user: number; content: string }) => {
    return this.post(data, `/admin/user/follow/`);
  };
  get_incomeList = (data: req_list) => {
    return this.get<res_list<income>>({ ...data },`/admin/income/`);
  };
   // 获取付款详情
   pay_check = (data: req_list) => {
    return this.get<pay_check>({ ...data }, `/admin/pay_check/`);
  }

  //用户新增会员卡
  add_user_meal = (data:add_user) => {
    return this.post(data,`/admin/add_user_meal/`)
  }

  update_user_meal = (data:{id:number,meal_id:string}) => {
    return this.post(data, `/admin/update_user_meal/`);
  };

  // 扫码支付
  scan_pay = (data: scan_pay) => {
    return this.postFullResponse<any>(data, `/admin/user_scan_pay/`)
  }

  // 获取支付宝二維碼
  user_ali_pay = (data: { order_no:string }) => {
    return this.post<any>(data,`/admin/user_ali_pay/`)
  }

}

export const api_user = new HttpUser("/admin/user/");
